import { useEffect, useState } from 'react';
import { useGetBFAwardsLeaderboardQuery } from 'common/store/modules/api/cfs-api';

/**
 * If there is a live season we should call the refetchLeaderBoardData in every pollingDelay interval
 *
 * @param leaderboardData - the current leaderboard data stored as an object - object
 * @param refetchLeaderboardData - a function to refetch the leaderboard data - function
 * @param seasonPid
 * @param pollingDelay - the delay between each poll for new leaderboard data - number
 */
export function useLeaderboardRefetch(
    seasonPid,
    pollingDelay = PULSE.app.common.CONSTANTS.TIME.THIRTY_SECS_IN_MS
) {
    const [pollingInterval, setPollingInterval] = useState(0);

    const { data: leaderboardData } = useGetBFAwardsLeaderboardQuery(
        {
            seasonId: seasonPid
        },
        {
            skip: !(seasonPid && seasonPid !== ''),
            pollingInterval: pollingInterval
        }
    );

    useEffect(() => {
        if (seasonPid && seasonPid !== '' && leaderboardData?.status) {
            setPollingInterval(
                PULSE.app.common.match.getMatchStatus(
                    leaderboardData?.status
                ) === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE
                    ? pollingDelay
                    : 0
            );
        }
    }, [seasonPid, leaderboardData]);
}
